import type { ReactNode } from 'react';

import EstimationDetailAssumptionsTab from '@/pages/estimation/detail/tabs/Assumptions';
import EstimationDetailCostSummaryTab from '@/pages/estimation/detail/tabs/CostSummary';
import EstimationDetailDirectCostTab from '@/pages/estimation/detail/tabs/DirectCost/index';
import EstimationDetailTab from '@/pages/estimation/detail/tabs/Estimation';
import EstimationDetailManagementReportTab from '@/pages/estimation/detail/tabs/ManagementReport';
import EstimationDetailMetadataTab from '@/pages/estimation/detail/tabs/Metadata';
import EstimationDetailProjectTab from '@/pages/estimation/detail/tabs/Project';
import EstimationDetailResourceCostTab from '@/pages/estimation/detail/tabs/ResourceCost';
import EstimationDetailResourcingTab from '@/pages/estimation/detail/tabs/Resourcing';
import EstimationDetailReviewTab from '@/pages/estimation/detail/tabs/Review';

import { eEstimationDetailTab } from '../model';

export const tabsConfiguration: { tabId: eEstimationDetailTab; content: ReactNode }[] = [
  {
    tabId: eEstimationDetailTab.project,
    content: <EstimationDetailProjectTab />,
  },
  {
    tabId: eEstimationDetailTab.metadata,
    content: <EstimationDetailMetadataTab />,
  },
  {
    tabId: eEstimationDetailTab.estimation,
    content: <EstimationDetailTab />,
  },
  {
    tabId: eEstimationDetailTab.assumptions,
    content: <EstimationDetailAssumptionsTab />,
  },
  {
    tabId: eEstimationDetailTab.resource,
    content: <EstimationDetailResourcingTab />,
  },
  {
    tabId: eEstimationDetailTab.resourceCost,
    content: <EstimationDetailResourceCostTab />,
  },
  {
    tabId: eEstimationDetailTab.directCost,
    content: <EstimationDetailDirectCostTab />,
  },
  {
    tabId: eEstimationDetailTab.costSummary,
    content: <EstimationDetailCostSummaryTab />,
  },
  {
    tabId: eEstimationDetailTab.managementReport,
    content: <EstimationDetailManagementReportTab />,
  },
  {
    tabId: eEstimationDetailTab.review,
    content: <EstimationDetailReviewTab />,
  },
];
